import React from "react";
import styles from "../User/Auth.module.css";

const AffiliateShareModal = ({ isOpen, onClose, affiliateCode }) => {
  if (!isOpen) return null;
  const affiliateLink = `${window.location.origin}/residencies?ref=${affiliateCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(affiliateLink);
    alert("Affiliate link copied to clipboard!");
  };

  const handleShare = (platform) => {
    const text = `Discover luxury accommodations at Aurelia Apartments! Explore our exclusive residencies: ${affiliateLink}`;
    let url = "";
    if (platform === "whatsapp") {
      url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    } else if (platform === "twitter") {
      url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
    } else if (platform === "facebook") {
      url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(affiliateLink)}`;
    } else if (platform === "email") {
      url = `mailto:?subject=Aurelia Apartments - Luxury Residencies&body=${encodeURIComponent(text)}`;
    }
    window.open(url, "_blank");
  };

  return (
    <div style={{position: "fixed", top:0, left:0, width:"100vw", height:"100vh", background:"rgba(0,0,0,0.3)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center"}}>
      <div style={{background:"#fff", borderRadius:"10px", padding:"32px", minWidth:"320px", maxWidth:"90vw", boxShadow:"0 2px 16px rgba(0,0,0,0.12)"}}>
        <button onClick={onClose} style={{float:"right", fontSize:"22px", background:"none", border:"none", cursor:"pointer"}}>&times;</button>
        <h2 className={styles.heading} style={{marginTop:0}}>Share Your Affiliate Link</h2>
        <div style={{marginBottom:"18px", wordBreak:"break-all"}}>
          <strong>Affiliate Link:</strong><br />
          <span style={{fontSize:"15px", background:"#f7f7f7", padding:"6px 10px", borderRadius:"5px", display:"inline-block", marginTop:"6px"}}>{affiliateLink}</span>
        </div>
        <button className={styles.button} style={{marginBottom:"12px"}} onClick={handleCopy}>Copy Link</button>
        <div style={{display:"flex", gap:"12px", flexWrap:"wrap"}}>
          <button className={styles.button} style={{background:"#25D366"}} onClick={()=>handleShare("whatsapp")}>WhatsApp</button>
          <button className={styles.button} style={{background:"#1DA1F2"}} onClick={()=>handleShare("twitter")}>Twitter</button>
          <button className={styles.button} style={{background:"#4267B2"}} onClick={()=>handleShare("facebook")}>Facebook</button>
          <button className={styles.button} style={{background:"#333"}} onClick={()=>handleShare("email")}>Email</button>
        </div>
      </div>
    </div>
  );
};

export default AffiliateShareModal;
